<template>
  <div class="d-flex">
    <v-skeleton-loader
      v-for="(width, index) of columnWidths"
      :key="index"
      boilerplate
      v-bind="$attrs"
      :width
      class="py-3 flex-grow-1"
    />
  </div>
</template>
<script setup lang="ts">
defineProps<{
  columnWidths: string[]
}>()
</script>
